import { Dispatcher } from '@Corim/architecture-backend'
import { Request } from '@Corim/architecture-backend'
import Apollo from './apollo'
import _ from 'lodash'
import { map, share } from 'rxjs/operators'
import { filter, observeOn, delay } from 'rxjs/operators'
import { queueScheduler, Observable } from 'rxjs'
import { from, of} from 'rxjs';

import {  tap, scan, distinctUntilChanged, mergeMap, groupBy,
  publishReplay, refCount,  startWith, shareReplay } from 'rxjs/operators'


const dispatch = (isProduction, log) => {
  let dispatch;

  const update$ = Observable.create(observer => {
    dispatch = action => observer.next(action)
  })
    .pipe(
      // Forces every value to get rendered before next value is calculated
      observeOn(queueScheduler),
      // Delay allows state to update in between the dispatches. 
      // If dispatch is able to continuously dispatch, a bug can occur where the lateststate does not update in between which can causing overriding of state values
      delay(1),
      share(),
    )

  update$.subscribe((event) => {
    if (!isProduction && log) {
      console.log(
        `%cDispatch:`,
        'background: green; color: white'
      )
      console.log(event)
    }
  });

  const checkId = (id, updateId) => {
    if (!_.isNil(id)) {
      const idTags = id.split('.')
      const updateTags = updateId.split('.')
      return idTags.reduce((acc, next, index) =>
        acc ? updateTags[index] === next || next === '*' : false, true)
    }
    else {
      return EMTPY
    }
  }

  // export const getId = (id) => update$
  //   .pipe(
  //     filter(update => checkId(id, update.id)),
  //     map(e => e.id)
  //   )



  // export const getActionWithMeta = (id, action) => update$
  // .pipe(
  //   filter(update => {
  //     const exists = checkId(id, update.id)
  //     return action ? exists && update.action === action : exists
  //   }
  //   )
  // )


  const getAction = (listener) => {
    if (!isProduction && _.isNil(listener)) {
      console.log("ID IS UNDEFINED IN GETACTION2")
    }
    const id = listener ? listener : ''
    const starred = id.substring(id.length-2, id.length) === '.*'
    return update$
      .pipe(
        filter(update => {
          if (starred) {
            const unstarredId = id.replace('.*', '')
            const listenerSubstring = unstarredId.split('.')
            const updateSubstring = update.id.split('.')
            return listenerSubstring.reduce((acc, next, index) => acc && updateSubstring[index] === next, true)
          }
          else {
            return id === update.id
          }
        }),
        map(update => {
          if (!starred) {
            return update.value
          } 
          else 
          {
            const unstarredId = id.replace('.*', '')
            let updatedId = update.id.replace(unstarredId, '')
            if (updatedId.substring(0, 1) === '.') {
              updatedId = updatedId.substring(1, updatedId.length)
            }
            return {id: updatedId, value: update.value}
          }
        })
      )
    }

  const nextAction = (id, value) =>
    dispatch({id: id, value: value})

  return {
    nextAction,
    getAction,
  }
}

const store = (isProductionVar, shouldLogVar) => {
  const isProduction = isProductionVar ?? (process?.env?.NODE_ENV === 'production') ?? true
  const shouldLog = shouldLogVar ?? process?.env?.LOG_STORE ?? process?.env?.REACT_APP_LOG_STORE
  //import StartingValues from '../StartingValues'
  const setObject = (object, keypath, value) => {
    const tempObject = _.cloneDeep(object)
    const oldValue = _.get(tempObject, keypath)
    const oldValueFixed = oldValue ? oldValue : {}
    return _.set(tempObject, keypath, { ...oldValueFixed, ...value })
  }

  let dispatch;

  const log = (text) => {
    if (!isProduction) {
      if (text === 'store') {
        console.log(
          `%cStore:`,
          'background: red; color: white'
        )
      }
      else if (text === 'update') {
        console.log(
          `%cUpdate:`,
          'background: blue; color: white'
        )
      }
      else {
        console.log(text)
      }
    }
  }

  const update$ = Observable.create(observer => {
    dispatch = action => observer.next(action)
  })
    .pipe(
      // Forces every value to get rendered before next value is calculated
      observeOn(queueScheduler)
    )

  const Store = update$
    .pipe(
      tap(e => (!isProduction && shouldLog) ? log('update') : null),
      tap(e => (!isProduction && shouldLog) ? log(e({})) : null),
      // If null, use previous
      scan((acc, next) => next(acc) ?? acc, {}),
      tap(e => (!isProduction && shouldLog) ? log('store') : null),
      tap(e => (!isProduction && shouldLog) ? log(e) : null),
      
      startWith({}),
      shareReplay(1)
    )

  Store.subscribe((event) => {});

  const getState = (keypath = null) => {
    if (_.isNil(keypath)) {
      return Store
    }
    else {
      return Store
        .pipe(
          mergeMap(e => {
            const unstarredId = keypath.replace('.*', '')
            const value = _.get(e, unstarredId)
            if (keypath.substring(keypath.length-2, keypath.length) === '.*'){
              return from(Object.keys(value).map(e => ({ id: e, value: { id: e, value: value[e] } })))
            }
            else {
              return of({ id: null, value })
            }
          }),
          groupBy(e => e.id),
          mergeMap(group => group
            .pipe(
              map(object => object.value),
              distinctUntilChanged((a, b) => _.isEqual(a, b))
            )
          ),
          filter(e => !_.isUndefined(e) ),
        )
      }
    }

    const getStateUndefined = (keypath = null) => {
      if (_.isNil(keypath)) {
        return Store
      }
      else {
        return Store
        .pipe(
          mergeMap(e => {
            const unstarredId = keypath.replace('.*', '')
            const value = _.get(e, unstarredId)
            if (keypath.substring(keypath.length-2, keypath.length) === '.*'){
              return from(Object.keys(value).map(e => ({ id: e, value: { id: e, value: value[e] } })))
            }
            else {
              return of({ id: null, value })
            }
          }),
          groupBy(e => e.id),
          mergeMap(group => group
            .pipe(
              map(object => object.value),
              distinctUntilChanged((a, b) => _.isEqual(a, b))
            )
          ),
        )
        }
      }

  const nextState = (key, value) => {
    return dispatch((acc) => {
        // Check to make sure new value is different from existing value
        if (!_.isEqual(_.get(acc, key), value))
        {
          // Clone for dev, otherwise set directly for speed
          return !isProduction ? _.set( _.cloneDeep(acc), key, value) : _.set(acc, key, value)
        }
        else {
          // Return null if no changes
          return null
        }
    })
  }

  const mergeState = (key, value) =>
    dispatch( (acc) => setObject(acc, key, value))
    //_.cloneDeep({...acc, [key]: { ...acc[key], ...value }}))

  // keypath.split('.').reduce((acc, next) => ({...acc, [next]: acc[next] ? {...acc[next]} : {} }))
  //scan((acc, next) => ({...acc, [next.key]: _.merge({}, acc[next.key], { [next.id]: next.value })}), {}),
  return {
    mergeState,
    nextState,
    getStateUndefined,
    getState
  }
}

const final = (isProduction, log) => {
  const Store = store(isProduction, log)
  const Dispatch = dispatch(isProduction, log)
  return {
    nextState: Store.nextState,
    mergeState: Store.mergeState,
    getState: Store.getState,
    nextAction: Dispatch.nextAction,
    getAction: Dispatch.getAction,
    getStateUndefined: Store.getStateUndefined,
  }
}

const dispatch2 = final(true, true)
Request(dispatch2, Apollo)

export default dispatch2